import { css } from 'emotion'

export const formContainer = css`
  width: 100%;
`
export const titleContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const mainTitle = css`
  font-weight: 400;
  font-size: 1.5em;
`
export const secondaryTitle = css`
  font-weight: 400;
  font-size: 1em;
  color: #a2a2a2;
`
export const modal = css`
  display: grid;
  padding: 20px;
  position: relative;
  top: 50%;
  left: 50%;
  width: 400px;
  background-color: #fff;
  border: 2px solid #000;
  border-radius: 10px;
  box-shadow: 1px 1px 43px 3px #000000ab;
  @media (max-width: 500px) {
    left: 10%;
    width: 300px;
  }
  #modal-modal-title{
    font-weight: bold;
  }
`
export const closeBtn = css`
  background: none;
  color: black;
  padding: 0;
  margin: 0;
  justify-self:end;
`
